import React from 'react';
import { Loader2 } from 'lucide-react';

export function LoadingBlock({ label = 'Loading...' }) {
    return (
        <div className="flex items-center gap-3 text-neutral-600 py-8 justify-center" data-testid="loading-state">
            <Loader2 className="h-4 w-4 animate-spin" />
            <span className="text-sm">{label}</span>
        </div>
    );
}

export function EmptyState({ icon: Icon, title, description, action }) {
    return (
        <div className="text-center py-12 px-4 border-2 border-dashed rounded-xl bg-white" data-testid="empty-state">
            {Icon && <Icon className="h-10 w-10 text-neutral-400 mx-auto mb-3" />}
            <div className="text-sm font-semibold text-neutral-900">{title}</div>
            {description && <div className="text-xs text-neutral-600 mt-1 max-w-md mx-auto">{description}</div>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}

export default LoadingBlock;
